import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Restricted from '../components/Restricted';
import RestrictedForm from '../components/RestrictedForm';
import UserMenuAdminCollapsed from '../components/Common/UserMenuAdminCollapsed';
import UserMenuCollapsedV3 from '../components/Common/UserMenuCollapsedV3';
import UserMenu from '../components/Common/UserMenu';
import UserMenuAdmin from '../components/Common/UserMenuAdmin';

const ProtectedRoute = ({
  component: Component, isAuthenticated, getUserProfileLoading, isRestricted, moduleName, isForm, user, ...rest
}) => {
  const [menuConfig, setMenuConfig] = useState(JSON.parse(localStorage.getItem('user_menu_config')));

  useEffect(() => {
    setMenuConfig(JSON.parse(localStorage.getItem('user_menu_config')));
  }, [user]);

  return (
    <Fragment>
      {getUserProfileLoading === false
        && (
          <Route
            {...rest}
            render={(props) => (isAuthenticated ? (
              <div className="protected-route">
                {isRestricted && (isForm ? <RestrictedForm moduleName={moduleName} /> : <Restricted moduleName={moduleName} isOrgActive />)}
                {menuConfig !== 'FIXED' ? (
                  <Fragment>
                    <div
                      style={{
                        width: '80px',
                        maxWidth: '80px',
                        minWidth: '80px',
                        position: 'fixed',
                        zIndex: '1000',
                      }}
                      id="z-index-1000" //! caution don't change the id
                    >
                      {window.location.pathname.includes('/admin/') ? <UserMenuAdminCollapsed /> : <UserMenuCollapsedV3 setMenuConfig={setMenuConfig} />}
                    </div>
                    <div className="app-container__collapsed">
                      <Component {...props} />
                    </div>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div
                      style={{
                        width: '230px',
                        maxWidth: '230px',
                        minWidth: '230px',
                        position: 'fixed',
                        zIndex: '1000',
                      }}
                      id="z-index-1000" //! caution don't change the id

                    >
                      {window.location.pathname.includes('/admin/') ? <UserMenuAdmin /> : <UserMenu setMenuConfig={setMenuConfig} />}
                    </div>
                    <div className="app-container">
                      <Component {...props} />
                    </div>
                  </Fragment>
                )}
              </div>
            ) : (
              <Redirect to={(window.location.pathname?.toString() !== '/' && window.location.pathname) ? `/login?callback=${window.location.pathname + window.location.search}` : '/login'} />)
            )}
          />
        )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  isAuthenticated: UserReducers.isAuthenticated,
  getUserProfileLoading: UserReducers.getUserProfileLoading,
  user: UserReducers.user,
});

export default connect(mapStateToProps)(ProtectedRoute);
